// Thin typed wrapper around /consent.js (public/consent.js), which every page
// loads from the site root. It keeps the visitor's cookie choice.
import { useEffect, useState } from "react";

export type ConsentChoice = "granted" | "denied" | "";

interface CmConsent {
  get: () => ConsentChoice;
  open: () => void;
  accept: () => void;
  reject: () => void;
}

declare global {
  interface Window {
    cmConsent?: CmConsent;
  }
}

/** Forget the choice and show the cookie banner again. */
export const openCookieSettings = () => window.cmConsent?.open();

/** The visitor's current choice, kept up to date as they change it. */
export const useConsentChoice = (): ConsentChoice => {
  const [choice, setChoice] = useState<ConsentChoice>("");
  useEffect(() => {
    const read = () => setChoice(window.cmConsent?.get() ?? "");
    read();
    // consent.js loads with defer, so it can arrive after the first render.
    const t = window.setTimeout(read, 500);
    window.addEventListener("cm-consent", read);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener("cm-consent", read);
    };
  }, []);
  return choice;
};
